export const getScheduledEventHistoryWithConnection = /* GraphQL */ `
  query GetScheduledEventHistory($id: ID!) {
    getScheduledEventHistory(id: $id) {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      scheduledEventMetadataId
      scheduledEventMetadata {
        id
        tenant
        landscape
        tenantLandscape
        title
        description
        jobId
        job {
          id
          tenant
          landscape
          tenantLandscape
          jobCode
          title
          description
          jobTriggerFilePath
          hasOutputFile
          createdAt
          updatedAt
        }
        repeatType
        rruleSet
        holidayExecutionType
        useCustomHoliday
        customHolidayLabels
        eventTriggerType
        createdBy
        updatedBy
        editedAt
        expirationDate
        createdAt
        updatedAt
      }
      eventStartDateTime
      jobId
      job {
        id
        tenant
        landscape
        tenantLandscape
        jobCode
        title
        description
        jobTriggerFilePath
        tasks {
          nextToken
        }
        hasOutputFile
        createdAt
        updatedAt
      }
      jobExecutionStatus
      tasks {
        items {
          version
          product
          batch
          batchName
          versionProductBatch
          jobId
          order
          jobIdOrder
          title
          includeInDownload
          createdAt
          updatedAt
        }
        nextToken
      }
      taskHistories {
        items {
          jobIdOrder
          jobId
          order
          scheduledEventHistoryId
          tenant
          landscape
          tenantLandscape
          taskStartDateTime
          taskEndDateTime
          taskExecutionStatus
          log
          outputFilePath
          includeInDownload
          taskTitle
          createdAt
          updatedAt
        }
        nextToken
      }
      executedBy
      executionArn
      createdAt
      updatedAt
    }
  }
`;

export const getScheduledEventHistories = /* GraphQL */ `
  query GetScheduledEventHistories(
    $tenantLandscape: String
    $eventStartDateTime: ModelFloatKeyConditionInput
    $nextToken: String
  ) {
    scheduledEventHistories: scheduledEventHistoriesByTenantLandscapeAndEventStartDateTime(
      tenantLandscape: $tenantLandscape
      eventStartDateTime: $eventStartDateTime
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        scheduledEventMetadataId
        eventStartDateTime
        jobExecutionStatus
        taskHistories {
          items {
            order
            taskExecutionStatus
            taskStartDateTime
            taskEndDateTime
            log
            includeInDownload
            taskTitle
            task {
              title
            }
          }
        }
        jobId
        job {
          id
          title
          hasOutputFile
        }
        executedBy
        updatedAt
      }
      nextToken
    }
  }
`;
